import brazilStatesCities from './brazil_states_cities.json';

export interface CityOption {
  id: string;
  name: string;
  displayName: string;
  stateName: string;
}

// Cache all cities for search functionality
let allCitiesCache: CityOption[] | null = null;

export const getAllCities = (): CityOption[] => {
  if (allCitiesCache) return allCitiesCache;
  
  const cities: CityOption[] = [];
  
  brazilStatesCities.forEach((state) => {
    state.cities.forEach((city) => {
      cities.push({
        id: `${state.id}-${city.name}`, // Unique key: stateId-cityName
        name: city.name, // City name for value
        displayName: `${state.name} - ${city.name}`, // Display format: "State Name - City Name"
        stateName: state.name,
      });
    });
  });
  
  // Sort alphabetically by display name
  allCitiesCache = cities.sort((a, b) => a.displayName.localeCompare(b.displayName, 'pt-BR'));
  return allCitiesCache;
};

export const searchCities = (query: string, limit = 10): CityOption[] => {
  if (!query || query.length < 1) return [];
  
  const allCities = getAllCities();
  const lowercaseQuery = query.toLowerCase();
  
  return allCities
    .filter(city => 
      city.name.toLowerCase().includes(lowercaseQuery) ||
      city.stateName.toLowerCase().includes(lowercaseQuery) ||
      city.displayName.toLowerCase().includes(lowercaseQuery)
    )
    .slice(0, limit);
};

export const getCityChoices = () => {
  return getAllCities().map(option => ({
    id: option.name, // Store just the city name as value
    name: option.displayName, // Display "State Name - City Name"
  }));
};
